import {
  AloftArea,
  CraftsmanCostProps,
  ORDER_FEATURES,
  getCraftsmanCost,
  isUndefined,
} from '@aloft/toolkit-shared';

import { selectImprovementsEntities } from '../propertyDataSelectors/improvementsSelectors.ts';
import { selectPropertyIdentificationEntities } from '../propertyDataSelectors/propertyIdentificationSelectors.ts';
import { createFeatureCostSelectors } from '../utils/createFeatureCostSelectors.ts';
import { selectCostProps } from './selectCostProps.ts';

const calculateSpaCost = (
  costProps: CraftsmanCostProps,
  improvements: ReturnType<typeof selectImprovementsEntities>,
  propertyIdentification: ReturnType<typeof selectPropertyIdentificationEntities>,
  id: string,
) => {
  const improvementsForTransaction = improvements[id];
  const identification = propertyIdentification[id];

  if (!improvementsForTransaction || !identification) return undefined;

  const { spa } = improvementsForTransaction;
  const {
    address: { PostalCode: zipCode },
  } = identification;

  if (
    !spa ||
    isUndefined(spa.hasFeature) ||
    isUndefined(spa.quality) ||
    isUndefined(zipCode) ||
    isUndefined(spa.area)
  ) {
    return undefined;
  }

  const calculator = getCraftsmanCost(costProps);

  return calculator.getSpaCost({
    hasFeature: ORDER_FEATURES.spa.hasFeature(improvementsForTransaction),
    sqft: AloftArea.schema.parse(spa.area),
    quality: spa.quality,
    zipCode,
  });
};

export const { selectSpaCost, selectZipOnlySpaCost, selectSpaCosts, selectSpaCostDisplay } =
  createFeatureCostSelectors({
    calculate: calculateSpaCost,
    inputSelectors: [
      selectCostProps,
      selectImprovementsEntities,
      selectPropertyIdentificationEntities,
    ],
    names: {
      cost: 'selectSpaCost',
      zipOnly: 'selectZipOnlySpaCost',
      costs: 'selectSpaCosts',
      display: 'selectSpaCostDisplay',
    },
  });
